(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'FlightPrices',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		function setupAirportTypeahead(inputSelector, onSelect) {
			Adzuki.Typeahead(
				inputSelector,
				'/Airports/search',
				onSelect,
				function template(item) {
					return item.name;
				},
				undefined,
				// FCTP-26: keep the server's order (exact airport code first). The
				// typeahead's default sorter moves names that merely start with the
				// typed letters ahead of it, so ATL listed Atlantic City first
				function keepServerOrder(items) {
					return items;
				}
			);
		}

		function reEnableStandardAirportFields() {
			var hasDeparture = $.trim($('#flightprices-departure_id_hidden').val()) !== '';
			var hasArrival = $.trim($('#flightprices-arrival_id_hidden').val()) !== '';

			$('#flightprices-departure_id').prop('disabled', hasDeparture);
			$('#flightprices-arrival_id').prop('disabled', hasArrival);
			$('.clear-departure-id').toggleClass('hidden', !hasDeparture);
			$('.clear-arrival-id').toggleClass('hidden', !hasArrival);
		}

		function getMultiCitySegmentDateValidationMessage() {
			var previousDate = null;
			var validationMessage = '';

			$('.multi-city-outbound-date').each(function eachSegmentDate(index, inputEl) {
				var segmentDate;
				var segmentNumber;

				if (validationMessage !== '') {
					return;
				}

				segmentNumber = index + 1;
				segmentDate = getSegmentDatePickerValue($(inputEl));

				if (!segmentDate) {
					return;
				}

				if (previousDate && segmentDate.isBefore(previousDate, 'day')) {
					validationMessage = 'Outbound date ' + segmentNumber + ' cannot be earlier than outbound date ' + index + '.';
					return;
				}

				previousDate = segmentDate.clone();
			});

			return validationMessage;
		}

		function toggleMultiCitySections(flightType) {
			if (flightType === 'multi_city') {
				$('.multi-city-segments').removeClass('hidden');
				$('.standard-flight-fields').closest('.form-group').addClass('hidden');
				$('.return-date').addClass('hidden');
				return;
			}

			clearMultiCitySegmentFields();
			$('.multi-city-segments').addClass('hidden');
			$('.standard-flight-fields').closest('.form-group').removeClass('hidden');
			reEnableStandardAirportFields();

			if (flightType === 'one_way') {
				$('.return-date').addClass('hidden');
			} else {
				$('.return-date').removeClass('hidden');
			}
		}

		function clearMultiCitySegmentFields() {
			$('.multi-city-segments-container').find('.multi-city-departure-hidden, .multi-city-arrival-hidden').val('');
		}

		function resetMultiCitySegments() {
			var template;
			var html;
			var i;
			var $segment;
			var departureName;
			var departureCode;
			var arrivalName;
			var arrivalCode;

			departureName = $('#flightprices-departure_id').val();
			departureCode = $('#flightprices-departure_id_hidden').val();
			arrivalName   = $('#flightprices-arrival_id').val();
			arrivalCode   = $('#flightprices-arrival_id_hidden').val();

			$('.multi-city-segments-container').empty();

			template = $('#multi-city-segment-template').html();
			for (i = 0; i < 2; i++) {
				html = template.replace(/__INDEX__/g, String(i)).replace(/__NUMBER__/g, String(i + 1));
				$('.multi-city-segments-container').append(html);
			}

			ensureSegmentIds();
			setupAllSegmentTypeaheads();
			initializeSegmentDatePickers();
			updateRemoveSegmentVisibility();

			if (departureCode && departureName) {
				$segment = $('.multi-city-segment').first();
				$segment.find('.multi-city-departure').val(departureName).prop('disabled', true);
				$segment.find('.multi-city-departure-hidden').val(departureCode);
				$segment.find('.multi-city-clear-departure').removeClass('hidden');
			}

			if (arrivalCode && arrivalName) {
				$segment = $('.multi-city-segment').first();
				$segment.find('.multi-city-arrival').val(arrivalName).prop('disabled', true);
				$segment.find('.multi-city-arrival-hidden').val(arrivalCode);
				$segment.find('.multi-city-clear-arrival').removeClass('hidden');
			}
		}

		function getSegmentDatePickerValue($input) {
			var picker;
			var pickerDate;

			picker = $input.data('DateTimePicker');
			if (picker && picker.date()) {
				return picker.date().clone().startOf('day');
			}

			pickerDate = moment($input.val(), 'MM/DD/YYYY', true);
			if (pickerDate.isValid()) {
				return pickerDate.startOf('day');
			}

			return null;
		}

		function syncSegmentDateConstraints() {
			var previousDate = moment().startOf('day');
			var maxDate = moment().add(11, 'months').startOf('day');

			$('.multi-city-outbound-date').each(function eachSegmentDate(index, inputEl) {
				var $input = $(inputEl);
				var picker = $input.data('DateTimePicker');
				var currentDate;

				if (!picker) {
					return;
				}

				picker.minDate(previousDate.clone());
				picker.maxDate(maxDate.clone());

				currentDate = getSegmentDatePickerValue($input);
				if (currentDate && currentDate.isBefore(previousDate, 'day')) {
					picker.date(previousDate.clone());
					currentDate = previousDate.clone();
					// FCTP-25: say why the date moved instead of changing it quietly
					showSegmentDateNotice($input, (index === 0
						? 'Outbound Date 1 moved to ' + previousDate.format('MM/DD/YYYY') + ' because it was in the past.'
						: 'Outbound Date ' + (index + 1) + ' moved to ' + previousDate.format('MM/DD/YYYY') + ' so it is not earlier than Outbound Date ' + index + '.'), 'has-warning');
				}

				if (currentDate) {
					previousDate = currentDate.clone();
				}
			});
		}

		function setupSegmentTypeahead($segment) {
			var $departure = $segment.find('.multi-city-departure');
			var $arrival = $segment.find('.multi-city-arrival');
			var $departureHidden = $segment.find('.multi-city-departure-hidden');
			var $arrivalHidden = $segment.find('.multi-city-arrival-hidden');

			setupAirportTypeahead('#' + $departure.attr('id'), function selectDeparture(item) {
				$departure.val(item.name);
				$departureHidden.val(item.code);
				$departure.prop('disabled', true);
				$segment.find('.multi-city-clear-departure').removeClass('hidden');
			});

			setupAirportTypeahead('#' + $arrival.attr('id'), function selectArrival(item) {
				$arrival.val(item.name);
				$arrivalHidden.val(item.code);
				$arrival.prop('disabled', true);
				$segment.find('.multi-city-clear-arrival').removeClass('hidden');
			});
		}

		function initializeSegmentDatePickers() {
			$('.multi-city-outbound-date').each(function eachDateInput(_, inputEl) {
				var $input = $(inputEl);

				if ($input.data('DateTimePicker')) {
					return;
				}

				if ($input.val()) {
					$input.attr('data-value', $input.val());
				}
				$input.attr('min', moment().format('YYYY-MM-DD'));
				$input.attr('max', moment().add(11, 'months').format('YYYY-MM-DD'));
				Adzuki.DateTimePicker($input, 'MM/DD/YYYY', 'YYYY-MM-DD');
				$input.on('dp.change', function _segmentDateChanged() {
					clearSegmentDateNotice($input);
					syncSegmentDateConstraints();
				});
				// FCTP-25: the picker empties a typed date outside its range and
				// fires dp.error; tell the advisor why the date disappeared
				$input.on('dp.error', function _segmentDateRejected(e) {
					showSegmentDateNotice($input, getRejectedSegmentDateMessage($input, e.date));
				});
				// FCTP-25: an empty picker opens on today's month, and a rejected
				// date sends it back there. When that month is before the segment's
				// earliest date the next arrow is disabled (the month after is still
				// too early), so the advisor is stuck; open on the earliest month.
				// viewDate() alone does not redraw an open picker, so the min date
				// is set again, which does, without choosing a date
				$input.on('dp.show', function _segmentPickerShown() {
					var picker = $input.data('DateTimePicker');
					var minDate = picker.minDate();

					if (minDate && !picker.date() && picker.viewDate().isBefore(minDate, 'month')) {
						picker.viewDate(minDate.clone());
						picker.minDate(minDate.clone());
					}
				});
			});

			syncSegmentDateConstraints();
		}

		function getRejectedSegmentDateMessage($input, rejectedDate) {
			var picker = $input.data('DateTimePicker');
			var index = $('.multi-city-outbound-date').index($input);
			var minDate = picker.minDate();
			var maxDate = picker.maxDate();

			if (rejectedDate && maxDate && rejectedDate.isAfter(maxDate, 'day')) {
				return 'Outbound Date ' + (index + 1) + ' cannot be later than ' + maxDate.format('MM/DD/YYYY') + '.';
			}

			if (index > 0 && minDate) {
				return 'Outbound Date ' + (index + 1) + ' cannot be earlier than Outbound Date ' + index + ' (' + minDate.format('MM/DD/YYYY') + '). Choose ' + minDate.format('MM/DD/YYYY') + ' or later.';
			}

			return 'Outbound Date ' + (index + 1) + ' cannot be in the past.';
		}

		function showSegmentDateNotice($input, message, stateClass) {
			var $group = $input.closest('.form-group');

			clearSegmentDateNotice($input);
			$group.addClass(stateClass || 'has-error');
			$('<span class="help-block multi-city-date-notice"></span>').text(message).insertAfter($input);
		}

		function clearSegmentDateNotice($input) {
			var $group = $input.closest('.form-group');

			$group.removeClass('has-error has-warning').find('.multi-city-date-notice').remove();
		}

		function ensureSegmentIds() {
			$('.multi-city-segment').each(function eachSegment(index, segmentEl) {
				var $segment = $(segmentEl);
				var $departure = $segment.find('.multi-city-departure');
				var $arrival = $segment.find('.multi-city-arrival');
				var $outboundDate = $segment.find('.multi-city-outbound-date');
				var baseId = 'flightprices-segments-' + index;

				$segment.attr('data-segment-index', index);
				$segment.find('.panel-heading strong').text('Segment ' + (index + 1));
				// renumber the trailing text only, so the required marker span stays (FCTP-26)
				$segment.find('label').each(function eachLabel(_, labelEl) {
					var textNode = labelEl.lastChild;

					if (textNode && textNode.nodeType === 3) {
						textNode.nodeValue = textNode.nodeValue.replace(/\d+(\s*)$/, (index + 1) + '$1');
					}
				});

				$departure.attr('id', baseId + '-departure_id');
				$arrival.attr('id', baseId + '-arrival_id');
				$outboundDate.attr('id', baseId + '-outbound_date');
				$segment.find(':input[name]').each(function eachInputName(_, inputEl) {
					var $input = $(inputEl);
					var currentName = String($input.attr('name'));
					$input.attr('name', currentName.replace(/\[segments\]\[\d+\]/, '[segments][' + index + ']'));
				});
			});
		}

		function updateRemoveSegmentVisibility() {
			var segmentCount = $('.multi-city-segment').length;

			if (segmentCount <= 2) {
				$('.multi-city-remove-segment').addClass('hidden');
			} else {
				$('.multi-city-remove-segment').removeClass('hidden');
			}
		}

		function setupAllSegmentTypeaheads() {
			$('.multi-city-segment').each(function setup(_, segmentEl) {
				setupSegmentTypeahead($(segmentEl));
			});
		}

		function addSegment() {
			var segmentCount = $('.multi-city-segment').length;
			var maxSegments = 5;
			var template;
			var html;
			var nextIndex;
			var $segment;
			var previousArrivalCode;
			var previousArrivalName;

			if (segmentCount >= maxSegments) {
				toastr.warning('A maximum of five segments is supported for multi-city searches.');
				return;
			}

			template = $('#multi-city-segment-template').html();
			nextIndex = segmentCount;
			html = template.replace(/__INDEX__/g, String(nextIndex)).replace(/__NUMBER__/g, String(nextIndex + 1));
			$('.multi-city-segments-container').append(html);
			ensureSegmentIds();

			$segment = $('.multi-city-segment').last();
			setupSegmentTypeahead($segment);
			initializeSegmentDatePickers();

			if (segmentCount > 0) {
				previousArrivalCode = $('.multi-city-segment').eq(segmentCount - 1).find('.multi-city-arrival-hidden').val();
				previousArrivalName = $('.multi-city-segment').eq(segmentCount - 1).find('.multi-city-arrival').val();

				if (previousArrivalCode && previousArrivalName) {
					$segment.find('.multi-city-departure').val(previousArrivalName).prop('disabled', true);
					$segment.find('.multi-city-departure-hidden').val(previousArrivalCode);
					$segment.find('.multi-city-clear-departure').removeClass('hidden');
				}
			}

			updateRemoveSegmentVisibility();
		}

		// departure airport
		setupAirportTypeahead(
			'#flightprices-departure_id',
			function select(item) {
				$('#flightprices-departure_id').val(item.name);
				$('#flightprices-departure_id_hidden').val(item.code);
				$('#flightprices-departure_id').prop('disabled', true);
				$('.clear-departure-id').removeClass('hidden');
			}
		);

		// arrival airport
		setupAirportTypeahead(
			'#flightprices-arrival_id',
			function select(item) {
				$('#flightprices-arrival_id').val(item.name);
				$('#flightprices-arrival_id_hidden').val(item.code);
				$('#flightprices-arrival_id').prop('disabled', true);
				$('.clear-arrival-id').removeClass('hidden');
			}
		);

		$('.clear-departure-id').on('click', function _clearDepartureId(e) {
			e.preventDefault();

			$('#flightprices-departure_id').val('');
			$('#flightprices-departure_id_hidden').val('');
			$('#flightprices-departure_id').prop('disabled', false);
			$('.clear-departure-id').addClass('hidden');
		});

		$('.clear-arrival-id').on('click', function _clearArrivalId(e) {
			e.preventDefault();

			$('#flightprices-arrival_id').val('');
			$('#flightprices-arrival_id_hidden').val('');
			$('#flightprices-arrival_id').prop('disabled', false);
			$('.clear-arrival-id').addClass('hidden');
		});

		$('#flightprices-outbound_date').on('dp.change', function _outboundDateChanged(e) {
			var val_date       = moment(e.date, "MM/DD/YYYY").add(1, 'days'),
				return_date    = $('#flightprices-return_date').data('DateTimePicker');

			if (e.date) {
				return_date.date(val_date);
			}
		});

		$('#flightprices-flight_type').on('change', function _flightTypeChanged(e) {
			var flight_type = $(e.target).val();

			if (flight_type === 'multi_city') {
				resetMultiCitySegments();
			} else {
				clearMultiCitySegmentFields();
			}

			toggleMultiCitySections(flight_type);
		});

		$('.multi-city-add-segment').on('click', function _addSegment(e) {
			e.preventDefault();
			addSegment();
		});

		$form.on('click', '.multi-city-clear-departure', function _clearSegmentDeparture(e) {
			var $segment;

			e.preventDefault();
			$segment = $(e.target).closest('.multi-city-segment');
			$segment.find('.multi-city-departure').val('').prop('disabled', false);
			$segment.find('.multi-city-departure-hidden').val('');
			$(e.target).addClass('hidden');
		});

		$form.on('click', '.multi-city-clear-arrival', function _clearSegmentArrival(e) {
			var $segment;

			e.preventDefault();
			$segment = $(e.target).closest('.multi-city-segment');
			$segment.find('.multi-city-arrival').val('').prop('disabled', false);
			$segment.find('.multi-city-arrival-hidden').val('');
			$(e.target).addClass('hidden');
		});

		$form.on('click', '.multi-city-remove-segment', function _removeSegment(e) {
			var $segment;

			e.preventDefault();
			if ($('.multi-city-segment').length <= 2) {
				return;
			}

			$segment = $(e.target).closest('.multi-city-segment');
			$segment.remove();
			ensureSegmentIds();
			setupAllSegmentTypeaheads();
			initializeSegmentDatePickers();
			updateRemoveSegmentVisibility();
		});

		$form.on('click', 'button[type="submit"]', function _validateSegmentDatesBeforeSubmit(e) {
			var validationMessage;

			if ($('#flightprices-flight_type').val() !== 'multi_city') {
				return;
			}

			validationMessage = getMultiCitySegmentDateValidationMessage();
			if (validationMessage !== '') {
				e.preventDefault();
				e.stopImmediatePropagation();
				toastr.error(validationMessage);
				return false;
			}
		});

		ensureSegmentIds();
		setupAllSegmentTypeaheads();
		initializeSegmentDatePickers();
		updateRemoveSegmentVisibility();
		reEnableStandardAirportFields();
		toggleMultiCitySections($('#flightprices-flight_type').val());
	};
}(jQuery, window.Adzuki || {}));
